import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { CheckForUpdateService } from './common/services/check-for-update.service';
import { SwUpdate } from '@angular/service-worker';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  title = 'Altasnim';
  updateAvailable = false;
  counter = 0;
  constructor(private updates: SwUpdate,
    private checkForUpdateService: CheckForUpdateService) {
    if (location.protocol === 'https:') {
      this.updates.available.subscribe((event) => {
        console.log('sw-event', event);
        this.updateAvailable = true;
        this.counter += 1;
        console.log(this.counter);
      });
      this.updates.checkForUpdate();
    }
  }

  onReload() {
    document.location.reload();
  }
}
